import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from '../../models/dialog-data';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css']
})
export class DialogComponent {

  public iconTitle?: string;
  public iconColor?: string;

  public constructor(public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    switch (data.title) {
      case "Alerta":
      case "Aviso":
      case "Erro":
      case "Excluir":
        this.iconTitle = "warning";
        this.iconColor = "red";
        break;
      case "Upload":
        this.iconTitle = "upload";
        break;
      case "Confirma":
        this.iconTitle = "help";
        this.iconColor = "blue";
        break;
      case "Sucesso":
        this.iconTitle = "check_circle";
        this.iconColor = "green";
        break;
      default:
        break;
    }
  }
}
